// Filter option definitions + currency formatting for the BathLane catalog.
// Filtering, sorting and facet counts are computed server-side by the catalog
// API; this module only supplies the UI's option lists and display helpers.

export const PRICE_BUCKETS = [
  { v: "Under ₹25,000", min: 0, max: 24999 },
  { v: "₹25,000 – ₹40,000", min: 25000, max: 39999 },
  { v: "₹40,000 – ₹55,000", min: 40000, max: 54999 },
  { v: "₹55,000+", min: 55000, max: Infinity },
];

// Enums used to render filter UI and to build the API's CSV query params.
export const FILTER_GROUPS = [
  {
    id: "mounting",
    label: "Mounting Type",
    param: "mounting",
    options: ["Wall Mounted", "Floor Mounted"],
  },
  {
    id: "width",
    label: "Width",
    param: "width",
    options: ['Under 18"', '18–24"', '24–30"', '30–36"', '36"+'],
  },
  {
    id: "sink",
    label: "Sink Type",
    param: "sink",
    options: ["Integrated Sink", "Countertop Compatible"],
  },
  {
    id: "style",
    label: "Style",
    param: "style",
    options: ["Modern", "Minimal", "Luxury", "Compact", "Storage-Focused", "Fluted"],
  },
  {
    id: "price",
    label: "Price",
    param: "price",
    options: PRICE_BUCKETS.map((b) => b.v),
  },
];

export const EMPTY_FILTERS = {
  mounting: [],
  width: [],
  sink: [],
  style: [],
  price: [],
};

export const totalActive = (filters) =>
  FILTER_GROUPS.reduce((n, g) => n + (filters[g.id]?.length || 0), 0);

// Build the CSV query params for /api/products from the active filters.
export const filterParams = (filters) => {
  const params = {};
  FILTER_GROUPS.forEach((g) => {
    const sel = filters[g.id];
    if (sel && sel.length) params[g.param] = sel.join(",");
  });
  return params;
};

export const SORTS = [
  { v: "recommended", label: "Recommended" },
  { v: "best", label: "Best Selling" },
  { v: "new", label: "New Arrivals" },
  { v: "price_asc", label: "Price: Low to High" },
  { v: "price_desc", label: "Price: High to Low" },
];

export const formatPrice = (n) => `₹ ${n.toLocaleString("en-IN")}`;